/** This is a temporary file for the AB Test - we'll create a global component if variant wins */
import {useEffect, useRef, useState} from 'react';
import cx from 'classnames';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {Typography} from '~library/atoms/Typography';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {DiamondIcon} from '~library/svg/DiamondIcon';
import {Button} from '~library/atoms/Button';

import {coin, ghost} from '~libSass/base/_exports.sass';
import './MultiSelect.sass';

const DISPLAY_NAMES = {
  'filter by': 'Free/Premium',
  'free or premium': 'Free/Premium',
  'show only': 'Features',
  color: 'Color',
  'featured brand': 'Brands',
  themes: 'Themes',
};

export const MultiSelect = ({
  filterType,
  filter,
  displayName = '',
  onToggle,
  activeFilters,
  rightAlign,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const newDisplayName = DISPLAY_NAMES[displayName.toLowerCase()] || '';
  const optionKeys = Object.keys(filter);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const isColorFilter = typeof filterType === 'string' && filterType.toLowerCase() === 'color';

  const matchingActiveFilters = activeFilters.filter((f) => f.sectionId === filterType);
  const filterNum = matchingActiveFilters.length === 0 ? '' : `(${matchingActiveFilters.length})`;

  return (
    <div className="multi-select_wrapper" ref={ref}>
      <Button
        variant="unstyled-button"
        className="multi-select top-filters_select"
        data-qa-id={`multiSelectDropdown-${displayName}`}
        onClick={() => setOpen(!open)}
      >
        <div className="multi-select_content">
          <Typography variant="paragraph2">
            {newDisplayName} {filterNum}
          </Typography>
          <ChevronIcon direction="down" ratio={0.75} color={coin} />
        </div>
      </Button>
      {open && (
        <div
          className={cx('multi-select_dropdown-menu', {
            'multi-select_dropdown-menu--right-align': rightAlign,
          })}
          data-qa-id={`multiSelectDropdown-${displayName}-menu`}
        >
          {optionKeys.map((option) => {
            const {display_name: filterDisplayName, enabled, on} = filter[option];
            if (!filterDisplayName) return null;
            return (
              <Button
                key={option}
                variant="unstyled-button"
                className={cx('multi-select_dropdown-menu-item', {
                  'multi-select_dropdown-menu-item--disabled': !enabled,
                })}
                data-qa-id={`multiSelectDropdown-${displayName}-${option}`}
                onClick={
                  enabled
                    ? (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onToggle(filterType, option, !on);
                      }
                    : undefined
                }
              >
                <div
                  className={cx('multi-select_checkbox', {
                    'multi-select_checkbox--checked': on,
                  })}
                >
                  {on && <CheckmarkIcon ratio={0.5} color={ghost} />}
                </div>
                <div className="multi-select_dropdown-menu-item_label-wrapper">
                  {filterDisplayName === 'Premium' && (
                    <DiamondIcon className="template-indicator-icon" ratio={1.25} />
                  )}
                  <Typography
                    className={cx('multi-select_dropdown-menu-item_label', {
                      'multi-select_dropdown-menu-item_label--disabled': !enabled,
                      'multi-select_dropdown-menu-item_label--premium':
                        filterDisplayName === 'Premium',
                    })}
                    variant="paragraph2"
                    color={filterDisplayName === 'Premium' ? 'roseWebText' : undefined}
                  >
                    {filterDisplayName}
                  </Typography>
                </div>
                {isColorFilter && (
                  <div
                    className={`multi-select_dropdown-menu-item_color filter-color-${filterDisplayName}`}
                  />
                )}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
};
